// extracted by mini-css-extract-plugin
export default {"optionClass":"select_optionClass__P2Kcs","circle":"select_circle__WIXtD"};